/**
 * ギフトバッグ追加ボックス（snippets/gift-bag-box.liquid）
 * - サイズ切替で価格・注記・画像を更新
 * - 「カートに入れる」でギフトバッグだけを /cart/add に送り、カートドロワーを再描画して開く
 *   （product-form.js と同じ流れ。ドロワーは Liquid 側で「ギフトバッグ未投入時のみ」表示される）
 * - ドロワー内に置かれても cart-drawer-items の change ハンドラ（数量更新）に拾われないよう伝播を止める
 */
if (!customElements.get('gift-bag-box')) {
  customElements.define(
    'gift-bag-box',
    class GiftBagBox extends HTMLElement {
      constructor() {
        super();
        this.addButton = this.querySelector('[data-gift-bag-add]');
        this.priceEl = this.querySelector('[data-gift-bag-price]');
        this.noteEl = this.querySelector('[data-gift-bag-note]');
        this.imageEl = this.querySelector('[data-gift-bag-image]');
        this.errorEl = this.querySelector('[data-gift-bag-error]');

        this.addEventListener('change', this.onChange.bind(this));
        if (this.addButton) this.addButton.addEventListener('click', this.onAdd.bind(this));
      }

      get selectedOption() {
        return this.querySelector('[data-gift-bag-option]:checked');
      }

      onChange(event) {
        event.stopPropagation();
        const option = event.target.closest('[data-gift-bag-option]');
        if (!option) return;

        if (this.priceEl) this.priceEl.textContent = option.dataset.price || '';
        if (this.noteEl) this.noteEl.textContent = option.dataset.note || '';
        if (this.imageEl && option.dataset.image) this.imageEl.src = option.dataset.image;
        this.showError(false);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.hidden = !message;
        this.errorEl.textContent = message || '';
      }

      onAdd(event) {
        event.preventDefault();
        const option = this.selectedOption;
        if (!option || !this.addButton || this.addButton.disabled) return;

        const cart = document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', option.value);
        formData.append('quantity', 1);
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.addButton.disabled = true;
        this.addButton.classList.add('is-loading');
        this.showError(false);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || 'カートに追加できませんでした。');
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'gift-bag-box',
              productVariantId: option.value,
              cartData: response,
            });
            cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.showError('カートに追加できませんでした。');
          })
          .finally(() => {
            // ドロワー内のボックスは再描画で消える。商品ページ側は再度押せるように戻す
            if (this.isConnected && this.addButton) {
              this.addButton.disabled = false;
              this.addButton.classList.remove('is-loading');
            }
          });
      }
    }
  );
}
